import React from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setMessageModal } from '../../actions/generalActions'
import { setConfirmModal } from '../../actions/generalActions'
import * as resource from '../../constants/Resources'
import * as settings from '../../constants/Settings';
import { continueFunction } from '../../actions/keyFunctionActions'
import { setSelectedObjectItem } from '../actions/objectManagementActions'
import { getTranslation, getLoggedInId, getSystemUser } from '../../actions/dataActions'
import { updateObjectItem, validNewLocation } from '../actions/objectManagementActions'
import { hasRight } from '../../actions/rightsActions'
import * as right from '../../constants/Rights'
import PropTypes from 'prop-types'
import * as types from '../../constants/Types'

class ObjectItemButton extends React.Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.getTimeDifference = this.getTimeDifference.bind(this);
  }

  componentWillUnmount() {
    //Production pos
    if (this.props.postype === types.POSTYPE_PRODUCTIONKIOSK) {
      clearInterval(this.interval);
    }
  };

  handleTouchTap() {
    const {
      locked,
      getLoggedInId,
      getSystemUser,
      userLocked,
      hasRight,
      setMessageModal,
      getTranslation,
      postype,
      receiptnumber,
      setSelectedObjectItem,
      continueFunction
    } = this.props;

    //Production pos: Prevent opening new objects on production pos 
    if (!receiptnumber && postype === types.POSTYPE_PRODUCTIONKIOSK) {
      return;
    }

    if (locked && !getLoggedInId(userLocked)) {
      if (hasRight(right.POS_UNBLOCK)) {
        setMessageModal(true, getTranslation(resource.RECEIPT_UNLOCKED));
      } else {
        if(userLocked){
          var user = getSystemUser(userLocked);
          if(user){
            var descr = getTranslation(resource.RECEIPT_ALREADY_OPEN);
            var userDesc = getTranslation(resource.USER);
            setMessageModal(true, `${descr} (${userDesc}: ${user.UserName})`);
            return;
          }
        }
        setMessageModal(true, getTranslation(resource.RECEIPT_ALREADY_OPEN));
        return;
      }
    }

    const objectitem = {
      id: this.props.id,
      capacity: this.props.capacity,
      itemtype: this.props.itemtype,
      number: this.props.number,
      objectgroupid: this.props.objectgroupid,
      receiptdatetime: this.props.receiptdatetime,
      receiptnumber: this.props.receiptnumber,
      text: this.props.text
    }

    setSelectedObjectItem(objectitem);
    continueFunction();
  }

  getTimeDifference(currentDateTime, receiptDateTime) {
    const timeDiff = Math.abs(currentDateTime.getTime() - receiptDateTime.getTime());
    const hours = parseInt(timeDiff / (1000 * 3600), 10);
    const minutes = parseInt(60 * ((timeDiff / (1000 * 3600)) - hours), 10);
    const totalDiffInMinutes = (hours * 60) + minutes;

    return {
      time: `${hours.pad()}:${minutes.pad()}`,
      showalarm: (totalDiffInMinutes >= settings.MAX_TIME_BEFORE_OBJECT_NOTIFICATION)
    };
  }

  render() {
    const {
      btnwidth,
      btnheight,
      btntop,
      btnleft,
      isDragging,
      postype,
      locked,
      receiptnumber,
      processed,
      customer
    } = this.props;

    const divstyle = {
      width: `${btnwidth}%`,
      height: `${btnheight}%`,
      top: `${btntop}%`,
      left: `${btnleft}%`,
      position: 'absolute',
      padding: '7px',
      display: isDragging ? 'none' : 'block',
    }

    

    //Production pos
    let itemButtonHeaderClassNames = 'om_itembuttonheader';
    const occupied = receiptnumber > 0;
    if(occupied){
      itemButtonHeaderClassNames += ' om_itembutton_occupied_header';
    }

    if (postype === types.POSTYPE_PRODUCTIONKIOSK && !processed) {
      itemButtonHeaderClassNames += ' blinkObjectManagementItemButton';
    }

    var textheader = this.props.text;
    if (customer !== "" && customer !== null) {
      textheader += " - " + customer;
    }

    return (<div style={divstyle}>
      <button className="om_itembutton" onClick={this.handleTouchTap}>
        <div className={itemButtonHeaderClassNames} >
          {occupied ?
            locked ?
              <div className="om_itemButtonNotification background_red"><i className="lock icon icon_margin_reset"></i></div> :
              <div className="om_itemButtonNotification background_green"><i className="checkmark icon icon_margin_reset"></i></div> :
            null
          }
          <div className="om_itemButtonText">
            <span>{textheader}</span>
          </div>
        </div>
        <div className={`om_itembuttonbody ${(occupied ? 'om_itembutton_occupied_body' : '')}`}>
          {this.props.number}
        </div>
        <Ink />
      </button>
    </div>)
  }
}

ObjectItemButton.propTypes = {
  setMessageModal: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    postype: state.generalState.posType,
    posid: state.generalState.posId
  }
}

export default connect(mapStateToProps, {
  setMessageModal,
  continueFunction,
  setSelectedObjectItem,
  getTranslation,
  getLoggedInId,
  getSystemUser,
  updateObjectItem,
  validNewLocation,
  hasRight,
  setConfirmModal
})(ObjectItemButton)



// WEBPACK FOOTER //
// src/objectmanagement/components/ObjectItemButton.jsx